import {State as StateType} from "@/store/api/stateApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface State{
    stateList: StateType[];
}

const initialState: State = {
    stateList: [],
}

const stateSlice = createSlice({
    name: "states",
    initialState,
    reducers: {
        setStates : (state, action: PayloadAction<StateType[]>) => {
            state.stateList = action.payload;
        },
        clearStates : (state) => {
            state.stateList = [];
        }
    }
})

export const {setStates, clearStates} = stateSlice.actions;
export default stateSlice.reducer;